module.exports = __webpack_public_path__ + "d701575a173e24d7379808d2b5940cb9.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/4_column_small_x1/public/history/fi-2006.png
// module id = 424
// module chunks = 0